import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClose = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.5842 12.8971L3.09888 4.41182L4.51309 2.99761L12.9984 11.4829L11.5842 12.8971Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.997 4.41581L4.51172 12.9011L3.09751 11.4869L11.5828 3.0016L12.997 4.41581Z",
		fill: "currentColor"
	})]
});
export { SvgClose as ReactComponent };
